<template>
	<section
		class="accordion"
		:class="{ 'prevent-events': noGMB || comingSoonOn }"
	>
		<div class="tab" :class="{ 'new-address': newAddress }">
			<input
				type="checkbox"
				class="accordion-checkbox"
				data-test="checkbox"
				:id="name"
				:name="name"
				ref="accordionInputRef"
			/>
			<label
				class="tab-label"
				:class="{ 'new-address': newAddress }"
				data-test="tab-label"
				id="tab-label"
				:for="name"
				tabindex="0"
				@keyup.enter="toggleAccordion($event)"
			>
				{{ accordionLabel }}
				<FormLabelTooltip :tooltip="tooltip" v-if="tooltip" class="tool-tip" />
				<span class="accordion-icon-wrapper">
					<span
						class="alert-enabled-tag"
						data-test="alert-enabled-tag"
						v-if="alertOn === true"
					>
						<font-awesome-icon
							class="alert-on-icon"
							:icon="['fas', 'check']"
						/>Enabled
					</span>
					<span
						class="alert-coming-soon-tag"
						data-test="alert-coming-soon-tag"
						v-if="comingSoonOn"
						>Coming Soon</span
					>
					<span
						class="primary-address-tag"
						data-test="primary-address-tag"
						v-if="isPrimaryAddress"
						>Primary Address</span
					>
					<font-awesome-icon
						class="accordion-toggle"
						:icon="['fal', 'chevron-circle-down']"
					/>
				</span>
			</label>
			<section v-if="!comingSoonOn" class="tab-content">
				<slot name="accordionContent" />
			</section>
		</div>
	</section>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'Accordion',
	components: {
		FormLabelTooltip,
	},
	props: {
		name: String,
		accordionLabel: String,
		alertOn: Boolean,
		comingSoonOn: Boolean,
		tooltip: String,
		noGMB: Boolean,
		isPrimaryAddress: Boolean,
		newAddress: Boolean,
	},
	methods: {
		toggleAccordion(event) {
			event.target.click();
		},
	},
};
</script>

<style lang="scss" scoped>
.accordion.prevent-events {
	pointer-events: none;
}
.b360-label-holder.tool-tip {
	pointer-events: auto;
}
.accordion {
	.accordion-checkbox {
		position: absolute;
		opacity: 0;
		z-index: -1;
	}

	.tab {
		width: 100%;
		color: $b360-color--gray__darkest;
		overflow: hidden;
		@include rem(margin-bottom, 15px);
		border-bottom-left-radius: $b360-border-radius-base;
		border-bottom-right-radius: $b360-border-radius-base;
		&.new-address {
			border: $b360-border-width-thin solid $brand-blue;
			border-radius: $b360-border-radius-base;
		}
		&-label {
			&.new-address {
				border-bottom: $b360-border-width-thin solid $brand-blue;
				border-radius: $b360-border-radius-base;
			}
			display: flex;
			justify-content: space-between;
			align-items: center;
			@include rem(padding, 15px);
			background: $white;
			font-weight: bold;
			cursor: pointer;
			border-radius: $b360-border-radius-base;
			border: $b360-border-width-thin solid $border-color-light;
			@include typo--roboto__medium;

			.accordion-icon-wrapper {
				margin-left: auto;
				display: flex;
			}

			.alert-enabled-tag {
				background-color: $success;
				color: $white;
				@include rem(font-size, 11px);
				@include rem(border-radius, 20px);
				@include rem(padding, 3px 8px);
				@include rem(margin-right, 10px);
				text-transform: uppercase;
				letter-spacing: 0.02rem;
				@include typo--roboto__bold;
				line-height: 1;
				display: inline-flex;
				align-items: center;

				.alert-on-icon {
					@include rem(margin-right, 6px);
					font-size: $b360-font-size--smaller;
					color: $white;
				}
			}

			.alert-coming-soon-tag,
			.primary-address-tag {
				background-color: $brand-blue;
				color: $white;
				@include rem(font-size, 11px);
				@include rem(border-radius, 20px);
				@include rem(padding, 3px 8px);
				@include rem(margin-right, 10px);
				text-transform: uppercase;
				letter-spacing: 0.02rem;
				@include typo--roboto__bold;
				line-height: 1;
				display: inline-flex;
				align-items: center;
			}
			.accordion-toggle {
				color: $brand-blue;
				font-size: $b360-font-size--larger;
				text-align: center;
				transition: all 0.35s ease-in-out;
			}
		}

		&-content {
			max-height: 0;
			@include rem(padding, 0 20px);
			color: $white;
			background: $white;
			transition: all 0.35s ease-in-out;
			visibility: hidden;
			opacity: 0;

			@include mobile {
				@include rem(padding, 0 7px);
			}
		}
	}

	// when the accordion is :checked
	input:checked {
		+ .tab-label {
			border-bottom-right-radius: unset;
			border-bottom-left-radius: unset;

			.accordion-toggle {
				transform: rotate(180deg);
			}
		}
		~ .tab-content {
			max-height: 5000px;
			color: $text-base-color;
			@include rem(padding, 0 20px);
			border: $b360-border-width-thin solid $border-color-light;
			border-top: none;
			border-bottom-left-radius: $b360-border-radius-base;
			border-bottom-right-radius: $b360-border-radius-base;
			visibility: visible;
			opacity: 1;

			@include mobile {
				@include rem(padding, 0 7px);
			}
		}
	}
}

.b360-label-holder {
	@include rem(margin-left, 5px);
}
</style>
